import React from "react";
import { View } from "react-native";
import {
  Panel,
  Pill,
  Text,
  useResponsive,
  Heading,
} from "@clearabee/ui-library-native";
import dayjs from "dayjs";
import { OrderTrain, StepName } from "components/OrderTrain/OrderTrain";
import { styles } from "./FeaturedJobPill.styles";

export interface FeaturedJobPillProps {
  countdown?: string;
  subheading: string;
  date: Date | string;
  service: React.ReactNode;
  timeslot: React.ReactNode;
  step: StepName;
  children?: React.ReactNode;
}

export const FeaturedJobPill = ({
  countdown,
  subheading,
  date,
  service,
  timeslot,
  step,
  children,
}: FeaturedJobPillProps): React.ReactElement => {
  const { screens } = useResponsive();

  return (
    <Panel styles={styles.activeJobPanel} shadow={false}>
      {countdown && (
        <Pill size="small" color="positive" styles={styles.activeJobPill}>
          <Text fontSize="xsmall2">{countdown}</Text>
        </Pill>
      )}
      <View style={{ flex: 1 }}>
        <Heading fontSize="xsmall2" styles={styles.subheading}>
          {subheading}
        </Heading>

        <Text fontSize="small">{service}</Text>
        <Text
          fontSize="small"
          color="brand"
          styles={{ fontFamily: "ProximaSemiBold" }}
        >
          {dayjs(date).format("ddd, Do MMMM YYYY")}
        </Text>

        <Text fontSize="small">{timeslot}</Text>
      </View>

      {screens.medium && (
        <View style={{ flex: 2 }}>
          <OrderTrain
            step={step}
            minified
            hideDescription
            titleSize="xsmall"
            iconSize="small"
          />
        </View>
      )}
      <View style={{ flex: 1 }}>{children}</View>
    </Panel>
  );
};
